import { testimonials } from '@/mocks/comics';

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <span key={i} className="w-3.5 h-3.5 flex items-center justify-center">
          <i className={`text-xs ${i < rating ? 'ri-star-fill text-primary-400' : 'ri-star-line text-foreground-300'}`}></i>
        </span>
      ))}
    </div>
  );
}

export default function TestimonialSection() {
  return (
    <section className="bg-background-200/70 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-lg mb-14">
          <span className="inline-block px-4 py-1.5 bg-primary-100/70 text-primary-700 text-xs font-medium rounded-full">
            用户好评
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mt-4 leading-tight">
            读者们都在<br />说什么
          </h2>
          <p className="text-foreground-600 text-sm mt-3 leading-relaxed">
            来自真实用户的声音，看看他们如何评价尾巴漫画的阅读体验
          </p>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6">
          {testimonials.map((item) => (
            <article
              key={item.id}
              className="break-inside-avoid mb-6 bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200 transition-colors duration-300"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.username}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="font-label text-sm font-semibold text-foreground-900">
                    {item.username}
                  </p>
                  <p className="text-foreground-500 text-xs">@reader_{item.id}</p>
                </div>
              </div>
              <StarRating rating={item.rating} />
              <p className="text-foreground-700 text-sm leading-relaxed mt-3">
                &ldquo;{item.comment}&rdquo;
              </p>
              <p className="text-foreground-400 text-xs mt-3">{item.date}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}